<p *ngIf="!viewAllHref" class="section-title" [ngClass]="{ active: active, 'mobile-layout': isMobileLayout }" (click)="toggleOpenClose()">
  {{sectionTitle}}
  <tl-icon-component *ngIf="isMobileLayout" [set]="'bootstrap'" [name]="'chevron-right'" [size]="'16px'"></tl-icon-component>
</p>
<a class="section-title" href="{{viewAllHref}}" *ngIf="viewAllHref">
  {{sectionTitle}}
</a>
<wvr-nav-list-component vertical="true" [ngClass]="{ active: active, 'mobile-layout': isMobileLayout }">
  <template nav-list-items>
    <ng-content select="tl-nav-li, tl-mega-menu-custom" ngProjectAs="wvre-nav-li"></ng-content>
  </template>
</wvr-nav-list-component>
